import { useSearchParams as useSearchParamsReact } from "react-router-dom";

export const useSearchParams = <T extends Record<string, string>>(): [T, URLSearchParams] => {
  const [searchParams] = useSearchParamsReact();
  const params = Object.fromEntries([...searchParams.entries()]) as T;
  return [params, searchParams];
};
